<template>
   <div id="navs">
       <div class="navbar navbar-fixed-top navbar-inverse" role="navigation">
           <div class="container navContainer" >
               <div class="navbar-header nav-title ">
                   <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                       <span class="sr-only">Toggle navigation</span>
                       <span class="icon-bar"></span>
                       <span class="icon-bar"></span>
                       <span class="icon-bar"></span>
                   </button>
                   <a  class="navbar-brand logo" href="javascript:;" style="margin-top: 5px"><img :src="$route.path=='/home'?'../../../static/images/logo.png':'../../../static/images/logo_white.png'" alt="logo"></a>
               </div>
               <div class="collapse navbar-collapse navbar-right is-collapse">
                   <ul class="nav navbar-nav">
                       <li v-for="(x,y) in links">
                           <router-link tag="a" :to="x.path" :key="y" exact :style="$route.path=='/home'?homeColor:ohterColor">
                               <span>{{x.name}}</span>
                           </router-link>
                       </li>
                       <li class="dropdown" style="color:#16b1b3" v-show="uid">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" style="color:#16b1b3;width:160px;background:none">
                                {{userdata.nickname ? userdata.nickname: num}}
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu" style="position:inherit;width:80px;">
                                <li><a href="#" style="color:#16b1b3;padding:10px 45px;" @click="goOut">退出登录</a></li>
                            </ul>
                            </li>
                   </ul>
               </div><!-- /.nav-collapse -->
           </div><!-- /.container -->
       </div>
   </div>

</template>

<script>
    import { getUserInfo } from '@/api/auth'
    import { setToken, setUid, getUid, removeToken, removeUid, getToken } from '@/utils/index'
    export default {
        name: "nav",
        data(){
            return {
                links:[
                    {
                        path:'/home',
                        name:'首页'
                    },
                    {
                        path:'/download',
                        name:'下载app'
                    },
                    {
                        path:'/custommade',
                        name:'企业定制'
                    }
                ],
                homeColor:{
                    color:'black'
                },
                ohterColor:{
                    color:'#ddd'
                },
                userdata: {},
                uid: '',
                num: '',
            }
        },
        methods:{
            async getUser() {
                if(getUid()) {
                    this.uid = getUid()
                    const { data } = await getUserInfo(this.uid) 
                    this.userdata = data.data.company_user
                    const reg = new RegExp("(\\d{3})(\\d{4})(\\d{4})")
                    this.num = this.userdata.mobile.replace(reg,"$1****$3")
                }
            },
            async goOut() {
                if (getToken() === undefined) {
                    throw Error('goOut: token is undefined!')
                }
                localStorage.clear()
                removeToken()
                removeUid()
                location.reload()
            }
        },
        mounted(){
            this.getUser()
        }
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width:768px){
        .logo {
            display:none;
        }
    }
    @media screen and (min-width:768px){
        .container{
            width: 75%;
            margin: 0 auto;
        }
    }
    .navbar-nav {
        margin:10px;
    }
    #navs .navbar-nav a .caret{
        display:inline-block;
    }
    .right-menu {
    float: right;
    height: 100%;
    line-height: 100%;
    &:focus{
     outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
      vertical-align: middle;
    }
    .screenfull {
      height: 20px;
      vertical-align: middle;
    }
    /*.international{
      vertical-align: top;
    }*/
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
    .username {
      color: #ffd04b;
    }
    .roles {
      color: aqua;
    }
    .navbar-inverse .navbar-nav>.open>a, .navbar-inverse .navbar-nav>.open>a:hover, .navbar-inverse .navbar-nav>.open>a:focus{
        background: none
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/common/nav.vue